var skin = "/skins/buy2bee";
var messageBoxDuration = 2500;